export default __webpack_public_path__ + "static/media/blog4.d416df13.jpg";